module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/80273036af50141f12d92825bda428cb.png";